import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";
import { fetchHotel } from "../../../../../Redux/slice/features/dropdownHotelSlice";

const CheckAvailability = () => {
  const dispatch = useDispatch();
  const hotels = useSelector((state) => state.hotels.hoteldata);
  const [selectedHotel, setSelectedHotel] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [availabilityData, setAvailabilityData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchHotel());
  }, [dispatch]);

  const handleCheckAvailability = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${REACT_APP_API_URL}api/checkAvailabilityAdmin/${selectedHotel}`,
        {
          check_in_date: checkInDate,
          check_out_date: checkOutDate,
        },
      );

      const rooms = Array.isArray(response.data?.data)
        ? response.data.data
        : [];
      const roomConfigs = Array.isArray(response.data?.roomConfigs)
        ? response.data.roomConfigs
        : [];

      const mergedRooms = rooms.map((room) => {
        const matchingConfig = roomConfigs.find(
          (config) => config.RoomTypeId === room.RoomConfigID,
        );

        return {
          ...room,
          ...(matchingConfig || {}),
        };
      });

      setAvailabilityData(mergedRooms);
    } catch (error) {
      console.error("Error checking availability:", error);
      setAvailabilityData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="card mb-3">
            <div className="card-header">
              <h6 className="card-title mb-0">Check Availability</h6>
            </div>
            <div className="card-body">
              <div className="row g-3 align-items-end">
                <div className="col-md-6 col-lg-3">
                  <label className="form-label text-muted">Hotel</label>
                  <select
                    className="form-select"
                    value={selectedHotel}
                    onChange={(e) => setSelectedHotel(e.target.value)}
                  >
                    <option value="">Select Hotel</option>
                    {hotels.map((hotel) => (
                      <option key={hotel.PropertyID} value={hotel.PropertyID}>
                        {hotel.UnitName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 col-lg-3">
                  <label className="form-label text-muted">Check In</label>
                  <input
                    type="date"
                    className="form-control"
                    value={checkInDate}
                    min={new Date().toISOString().split("T")[0]}
                    onChange={(e) => setCheckInDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 col-lg-3">
                  <label className="form-label text-muted">Check Out</label>
                  <input
                    type="date"
                    className="form-control"
                    value={checkOutDate}
                    min={checkInDate}
                    onChange={(e) => setCheckOutDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 col-lg-3">
                  <button
                    type="button"
                    className="btn btn-success w-100"
                    onClick={handleCheckAvailability}
                  >
                    Check Availability
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card mb-3">
            <div className="card-header">
              <h6 className="card-title mb-0">Room Availability</h6>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Room Type</th>
                      <th>Total Rooms</th>
                      <th>Available Rooms</th>
                      <th>Price Per Day</th>
                      <th>Extra Person Charge</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : availabilityData.length > 0 ? (
                      availabilityData.map((room, index) => (
                        <tr key={`${room.RoomConfigID}-${index}`}>
                          <td>{room.RoomConfig || room.RoomType || "-"}</td>
                          <td>{room.TotalRooms ?? "-"}</td>
                          <td>{room.AvailableRooms ?? "-"}</td>
                          <td>{room.PricePerDay ?? "-"}</td>
                          <td>{room.ExtraPersonRate ?? "-"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckAvailability;
